export default {
  en: {
    'AUTO_REFRESH': 'Auto Refresh'
  }
};